import React from 'react';
import WalletBalance from '../../components/WalletBalance';
import Wallet from '../../components/Wallet';

const WalletPage = (props) => {
  const { classes } = props;
  return (
    <div className={classes.wrap}>
      <WalletBalance/>
      <div>
        <Wallet/>
      </div>
    </div>
  );
};

export default WalletPage;
